
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.723 7.025l6.437 2.683-6.446-.833.009-1.85zm6.428 7.267l-6.437 2.683v-1.85l6.437-.833zM3.009 4.5L3 10.333 15.857 12 3 13.667l.009 5.833L21 12 3.009 4.5z","fill-rule":"nonzero"}})])
          )
        }
      }
    